<template>
  <el-cascader
    :value="value"
    :options="options"
    :props="{
      checkStrictly: checkStrictly || false,
      value: 'area_name',
      label: 'area_name',
      children: 'child',
    }"
    clearable
    :placeholder="placeholder"
    @clear="$emit('clear')"
    @change="changeValue"
  ></el-cascader>
</template>

<script>
import { getAreaLists } from "@/api/common.js";
export default {
  model: {
    prop: "value",
    event: "input",
  },
  props: ["value", "placeholder", "checkStrictly", "emitPath"],
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getArea();
  },
  methods: {
    changeValue(val) {
      console.log(val);

      if (!val) {
        this.$emit("clear");
      }
      if (val instanceof Array) {
        this.$emit("input", val);
        this.$emit("province", val[0]);
        this.$emit("city", val[1]);
        this.$emit("area", val[2]);
        this.$emit("addr", val.join(" "));
      } else {
        this.$emit("input", val);
      }
      console.log(this.value);
    },
    getArea() {
      getAreaLists().then((res) => {
        if (res instanceof Array) {
          this.options = res;
        }
      });
    },
  },
};
</script>

<style></style>
